var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__logo",on:{"click":function($event){_vm.$emit('click')}}},[_c('a',{attrs:{"href":!_vm.editMode && _vm.$router.resolve({ name: 'user-profile' }).href}},[(_vm.logoUrl)?_c('img',{attrs:{"src":_vm.logoUrl}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bc3d4fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/HeaderLogo.vue
// module id = 99
// module chunks = 0